import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { QFormControl, QSelect, QSelectItem, QSelectPlaceholder, QText } from '@qualio/ui-components';

export const DueFilter = ({ dueList }: { dueList: QSelectItem[] }) => {
  const { t } = useTranslation();
  return (
    <QFormControl label={t('common.labels.due')} data-cy="due-filter" w="300px">
      <Controller
        name={'is_overdue'}
        render={({ field: { ref: _ref, onChange, value, ...field } }) => (
          <QSelect
            {...field}
            options={dueList}
            onChange={(changeObject) => {
              onChange(changeObject?.value ?? '');
            }}
            aria-label="due-filter"
            isClearable={true}
            value={value ?? ''}
            key={`event-due-${value}`}
          >
            <QSelectPlaceholder>
              <QText>{t('common.filters.filterByDueStatus')}</QText>
            </QSelectPlaceholder>
          </QSelect>
        )}
      />
    </QFormControl>
  );
};

export default DueFilter;
